import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { AlertTriangle, Package, Search } from "lucide-react";

export default function VetInventory() {
  const [meds, setMeds] = useState([]);
  const [lowStock, setLowStock] = useState([]);
  const [query, setQuery] = useState("");

  const load = () => axios.get(`${API}/partner/vet/inventory`).then(r => { setMeds(r.data.medicines); setLowStock(r.data.low_stock); });
  useEffect(() => { load(); }, []);

  const update = async (id, q, threshold) => {
    await axios.patch(`${API}/partner/vet/inventory/${id}`, { quantity: q, low_stock_threshold: threshold });
    load();
  };

  const filtered = meds.filter(m => !query || m.name.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="space-y-6" data-testid="vet-inventory-page">
      <header>
        <div className="text-xs uppercase tracking-[0.2em] text-brand font-bold">My Clinic</div>
        <h1 className="font-heading text-3xl font-extrabold mt-1">Medicine Inventory</h1>
        <p className="text-ink-soft text-sm">Track stock levels and get alerted before you run out.</p>
      </header>
      {lowStock.length > 0 && (
        <div data-testid="low-stock-banner" className="bg-brand/10 border border-brand/30 rounded-2xl p-4 flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-brand"/>
          <div className="flex-1">
            <div className="font-bold">{lowStock.length} medicine{lowStock.length>1?"s":""} running low</div>
            <div className="text-xs text-ink-soft mt-0.5">{lowStock.slice(0, 3).map(m => m.name).join(", ")}{lowStock.length > 3 ? ` +${lowStock.length-3} more` : ""}</div>
          </div>
        </div>
      )}
      <div className="bg-surface border border-line rounded-full px-4 py-2.5 flex items-center gap-2">
        <Search className="w-4 h-4 text-ink-soft"/>
        <input value={query} onChange={e => setQuery(e.target.value)} placeholder="Search medicine…" className="flex-1 outline-none bg-transparent font-bold" data-testid="inventory-search"/>
      </div>
      <div className="bg-surface border border-line rounded-3xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-surface-muted text-left">
            <tr><th className="p-3">Medicine</th><th className="p-3">Strength</th><th className="p-3 w-32">Stock</th><th className="p-3 w-32">Low at</th><th className="p-3"></th></tr>
          </thead>
          <tbody>
            {filtered.map(m => <Row key={m.medicine_id} m={m} onSave={(q, t) => update(m.medicine_id, q, t)}/>)}
          </tbody>
        </table>
        {filtered.length === 0 && <div className="p-8 text-center text-ink-soft"><Package className="w-8 h-8 mx-auto mb-2 opacity-50"/>No medicines yet. Add some at /app/vet/medicines.</div>}
      </div>
    </div>
  );
}

function Row({ m, onSave }) {
  const [q, setQ] = useState(m.quantity ?? 0);
  const [t, setT] = useState(m.low_stock_threshold ?? 5);
  const isLow = q <= t;
  return (
    <tr className="border-t border-line">
      <td className="p-3 font-bold">{m.name}</td>
      <td className="p-3 text-ink-soft">{m.strength || "—"}</td>
      <td className="p-3"><input data-testid={`stock-${m.medicine_id}`} type="number" value={q} onChange={e => setQ(Number(e.target.value))} className={`w-20 inp text-center ${isLow ? "border-brand" : ""}`}/></td>
      <td className="p-3"><input type="number" value={t} onChange={e => setT(Number(e.target.value))} className="w-20 inp text-center"/></td>
      <td className="p-3 text-right">
        <button onClick={() => onSave(q, t)} className="bg-ink text-white rounded-full px-3 py-1.5 text-xs font-bold">Save</button>
        {isLow && <span className="ml-2 text-[10px] uppercase tracking-wider font-bold text-brand">Low</span>}
        <style>{`.inp{border:1px solid #EAE0D5;border-radius:10px;padding:0.4rem 0.5rem;background:#FFFDF7;font-family:'Nunito';font-weight:700;outline:none;}.inp:focus{border-color:#FF6B35;}`}</style>
      </td>
    </tr>
  );
}
